module.exports = "table {\n  white-space: nowrap; }\n\n.table-div {\n  max-width: 100%;\n  overflow: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-allowance-proposal.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-allowance-proposal.component.scss
// module chunks = main